import moment from "moment";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { downloadCsv } from "../../utils";

const REGISTRATION_STATUS = [1, 2];

export const exporter = (data) => {
    const dataForExport = data.map((item) => ({
      Nome: item.name,
      Sobrenome: item.lastName,
      "E-mail": item.email,
      "Tipo de Documento": item.typeUser ? item.typeUser.name : "",
      Documento: item.document,
      CPF: item.cpf,
      Telefone: item.phone,
      Gênero: item.genderUser?.name || "",
      "Notificações Autorizadas": item.authorizedNotifications,
      "E-mail Verificado": item.verifiedAccount,
      "Tutorial Visualizado": item.seenTutorial,
      Função: item.roleUser ? item.roleUser.name : "",
      Especialidades:
      item.specialtiesUsers && item.specialtiesUsers.length > 0
          ? item.specialtiesUsers.map(({ specialties }) => specialties.name).join(", ")
          : "",
      "Data de Criação": moment(item.createdAt).format("DD/MM/YYYY"),
      "Data de Registro": item.registeredAt
        ? moment(item.registeredAt).format("DD/MM/YYYY")
        : "",
      "Último Login": item.lastLogin ? moment(item.lastLogin).format("DD/MM/YYYY") : "",
      Celular: item.cellPhone,
      "Status do Usuário": REGISTRATION_STATUS.includes(item.statusUserId)
        ? "cadastrado"
        : "lead",
    }));
  
    const csv = convertToCSV(
      {
        data: dataForExport,
        fields: [
          "Nome",
          "Sobrenome",
          "E-mail",
          "Tipo de Documento",
          "Documento",
          "CPF",
          "Telefone",
          "Gênero",
          "Notificações Autorizadas",
          "E-mail Verificado",
          "Tutorial Visualizado",
          "Função",
          "Especialidades",
          "Data de Criação",
          "Data de Registro",
          "Último Login",
          "Celular",
          "Status do Usuário",
        ],
      },
      {
        delimiter: ";",
      }
    );
  
    downloadCsv(csv, "users");
  };
  
  export const exporterConfirmedBox = (data) => {
    const dataForExport = data.map((item) => ({
      Nome: item.user ? item.user.name : "",
      Documento: item.user ? item.user.document : "",
      Ciclo: item.cycle ? item.cycle.id : "",
      "E-mail": item.user ? item.user.email : "",
      Laboratórios:
        item.labsList && item.labsList.length > 0
          ? item.labsList.map(({ lab }) => lab).join(", ")
          : "",
      "Última Atualização": item.user
        ? moment(item.user.updatedAt).format("DD/MM/YYYY")
        : "",
    }));
  
    const csv = convertToCSV(
      {
        data: dataForExport,
        fields: [
          "Nome",
          "Documento",
          "Ciclo",
          "E-mail",
          "Laboratórios",
          "Última Atualização",
        ],
      },
      {
        delimiter: ";",
      }
    );
  
    downloadCsv(csv, "withConfirmedBox");
  };
